<template>
  <div class="menu">
    <!--    <div class="menu-top">-->
    <!--      <i class="el-icon-arrow-left"/>-->
    <!--      统计分析-->
    <!--    </div>-->
    <div class="menu-main">
      <ul>
        <li>
          <i class="el-icon-document-copy"/>
          <router-link to="/#" target="_blank">工单扫描明细</router-link>
        </li>
        <li>
          <i class="el-icon-document-copy"/>
          <router-link to="/#" target="_blank">排产数量明细</router-link>
        </li>
        <li>
          <i class="el-icon-document-copy"/>
          <router-link :to="'/invoiceCountList/'" target="_blank">
            中间仓统计数据
          </router-link>
        </li>
        <li>
          <i class="el-icon-document-copy"/>
          <router-link to="/#" target="_blank">工序完成统计</router-link>
        </li>
        <li>
          <i class="el-icon-document-copy"/>
          <router-link to="/#" target="_blank">生产过账统计</router-link>
        </li>
        <li>
          <i class="el-icon-document-copy"/>
          <router-link to="/#" target="_blank">装箱物料扫描记录</router-link>
        </li>
        <li>
          <i class="el-icon-document-copy"/>
          <router-link to="/#" target="_blank">部件状态表</router-link>
        </li>
        <li>
          <i class="el-icon-document-copy"/>
          <router-link to="/#" target="_blank">客户销售价格清单</router-link>
        </li>
        <li>
          <i class="el-icon-document-copy"/>
          <!--          <router-link to="/#" target="_blank">销售额区域汇总</router-link>-->
          <router-link :disabled="!seeAuth" :to="'/regionalSalesSummary/'" target="_blank">
            销售额区域汇总
          </router-link>
        </li>
        <li>
          <i class="el-icon-document-copy"/>
          <router-link :to="'/completionEfficiency/'" target="_blank">
            完成效率统计
          </router-link>
        </li>
        <li>
          <i class="el-icon-document-copy"/>
          <router-link to="/#" target="_blank">开工发货数量统计</router-link>
        </li>
        <li>
          <i class="el-icon-document-copy"/>
          <router-link to="/#" target="_blank">OTD</router-link>
        </li>
      </ul>
    </div>
    <div>
      {{userName}}
    </div>
  </div>
</template>
<script>
  import loginUtil from "../../util/loginUtil";
  export default {
    name:"MenuList",
    components: {},
    data() {
      return {
        seeAuth: this.$auth(905),
        userName: "111",
        userInfo: "",
      };
    },
    created() {
      window.getParamsFromOc = this.getParamsFromOc;
    },
    mounted() {
      let android = navigator.userAgent.match(/(Android)/i);
      let iPhone = navigator.userAgent.match(/(iPhone)/i);
      if (android) {
        let userInfo = JSON.parse(window.userInfo.getUserInfo());
        if (userInfo.userName!=="") {
          loginUtil.login(userInfo);
        }
      }else if (iPhone) {
        let userInfo = window.webkit.messageHandlers.getUserInfo.postMessage("111");
        console.log(userInfo);
        // this.userName = userInfo.userName;
        // let userInfo1 = window.webkit.messageHandlers.getUserInfo.postMessage(userInfo);
        // console.log(userInfo);
        // this.userName = userInfo.userName;
        // if (userInfo.userName!=="") {
        //   loginUtil.login(userInfo);
        // }
      }
    },
    methods: {
    },
  };
</script>


<style lang="scss" scoped>
  @media (min-width: 320px) and (max-width: 369px) {
    .menu-top{
      padding: 15px 0!important;
      font-size: 18px!important;
    }
    ul{
      li:nth-child(2),li:nth-child(4),li:nth-child(6),li:nth-child(8),li:nth-child(10),li:nth-child(12){
        border-right: none!important;
      }
      li{
        width: 49.8%!important;
        font-size: 12px!important;
        i{
          margin: 0 5px!important;
        }
        a{
          text-decoration: none;
          font-size: 12px!important;
        }
      }
    }
  }
  @media (min-width: 370px) and (max-width: 760px) {
    ul{
      li:nth-child(3),li:nth-child(6),li:nth-child(9),li:nth-child(12){
        border-right: none!important;
      }
      li{
        width: 33.15%!important;
        font-size: 12px!important;
        i{
          margin: 0 5px!important;
        }
        a{
          text-decoration: none;
          font-size: 12px!important;
        }
      }
    }
  }
  @media (min-width: 761px) and (max-width: 1289px) {
    ul{
      li:nth-child(4),li:nth-child(8),li:nth-child(12){
        border-right: none!important;
      }
      li{
        width: 24.9%!important;
        font-size: 14px!important;
        a {
          text-decoration: none;
          font-size: 14px!important;
        }
      }
    }
  }
  .menu{
    .menu-top{
      background: url("../../../public/img/topbg.png") no-repeat;
      background-size: 100% 100%;
      color: #ffffff;
      font-size: 1.3em;
      text-align: center;
      position: relative;
      padding: 20px 0;
      width: 100%;
      i{
        position: absolute;
        top: 50%;
        left: 30px;
        transform: translateY(-50%);
      }
    }
    .menu-main{
      ul,li{
        list-style: none;
      }
      ul{
        width: 100%;
        padding: 0;
        margin: 0;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        li{
          width: 16.59%;
          padding: 10px 0;
          font-size: 1em;
          border-bottom: 1px solid #eeeeee;
          border-right: 1px solid #eeeeee;
          i{
            color: #2D8CF0;
            margin: 0 10px 0 25px;
          }
          a {
            text-decoration: none;
            font-size: 1em;
            color: black;
          }
        }
      }
    }
  }

</style>
